import React, { useReducer, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import axios from 'axios';

import AuthenticationDispatch from '../../contexts/authenticationDispatch';
import authenticationReducer from '../../reducers/authentication.reducer';
import authenticationActions from '../../actions/authentication.actions';

import LoginForm from './LoginForm';
import NewUser from './NewUser';
import style from './LoginPage.module.css';

const LoginPage = React.memo(({ history }) => {
  const [state, dispatch] = useReducer(authenticationReducer, {
    loggedIn: false,
    newUser: false,
    clientId: null,
  });

  const { loggedIn, newUser } = state;
  const queryParameters = history.location.search;
  const params = new URLSearchParams(queryParameters);
  const token = params.get('token');
  const agencyId = params.get('AgencyId');
  const clientId = params.get('clientId');

  useEffect(() => {
    const handleSuccess = ({ data }) => {
      localStorage.setItem('token', data.Token);
      localStorage.setItem('refresh', data.RefreshToken);
      localStorage.setItem('agencyId', data.Agency.AgencyId);

      dispatch({
        type: authenticationActions.AUTHENTICATION_EXTERNAL_SUCCESS,
        clientId,
      });
    };

    if (token && agencyId) {
      axios
        .post(`${process.env.REACT_APP_BASE_URL}account/external-login`, {
          AgencyId: agencyId,
          Token: token,
        })
        .then(handleSuccess);
    }

    document.title = 'HUB Portal: Login';
  }, [agencyId, clientId, token]);

  return !loggedIn ? (
    <AuthenticationDispatch.Provider value={dispatch}>
      <section className={style.login}>
        <h1 className={style.h1}>Welcome HUB</h1>
        <h3 className={style.h3}>
          Access your Small Business Management Liability Portal
        </h3>
        <div className={`container ${style.container}`}>
          <div className={style.wrapper}>
            <LoginForm />
          </div>
        </div>
        <NewUser newUser={newUser} />
      </section>
    </AuthenticationDispatch.Provider>
  ) : (
    <Redirect to={clientId ? `/clients/${clientId}` : '/'} />
  );
});

export default LoginPage;
